import { useContext, useEffect, useState } from 'react'
import { DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Spinner } from 'components/Spinner'
import { errorToast, ToastContext } from 'components/Toast/Toast'
import { PartnershipsApiClient } from 'utils/api/partnershipsApi'

import { IntroducingBrokerDetailsDto } from '../../../api/Trading-Accounts/Types/IntroducingBrokerDetailsDto'
import { IntroducingBrokerMultiTierDetails } from '../../../api/Trading-Accounts/Types/IntroducingBrokerMultiTierDetails'
import { MultiTierNetworkDto } from '../../../api/Trading-Accounts/Types/MultiTierNetworkDto'
import { useApiClient } from '../../../utils/api/ApiClient'
import {
  IntroducingBrokerMTNetworkSubAccountEditForm,
  UpdateIntroducingBrokerMultiTierSubAccountFormValues,
} from './IntroducingBrokerMTNetworkSubAccountEditForm'

interface Props {
  introducingBroker: IntroducingBrokerDetailsDto
  data: MultiTierNetworkDto
  onSubmit(
    introducingBrokerId: string,
    values: UpdateIntroducingBrokerMultiTierSubAccountFormValues
  ): Promise<void>
  onClose(): void
}
export const IntroducingBrokerMTNetworkSubAccountEditModal: React.FC<Props> = (props) => {
  const { data, onSubmit, onClose } = props
  const partnershipsApiClient = useApiClient(PartnershipsApiClient)
  const setToast = useContext(ToastContext)
  const [aggregatedData, setAggregatedData] = useState<IntroducingBrokerMultiTierDetails>()

  useEffect(() => {
    let isCurrent = true
    setAggregatedData(undefined)

    partnershipsApiClient
      .getIntroducingBrokerMultiTierNetworkDetails(data.introducingBroker.id)
      .then((response) => {
        if (isCurrent) {
          setAggregatedData(response)
        }
      })
      .catch(() => {
        if (!isCurrent) return

        setToast(errorToast('Failed to load Sub-IB Profile.'))
        onClose()
      })

    return () => {
      isCurrent = false
    }
  }, [data.introducingBroker.id, onClose, partnershipsApiClient, setToast])

  if (!aggregatedData) {
    return (
      <DialogContent size='lg'>
        <DialogHeader>
          <DialogTitle>Edit Sub-IB Profile</DialogTitle>
        </DialogHeader>
        <Spinner />
      </DialogContent>
    )
  }

  return (
    <IntroducingBrokerMTNetworkSubAccountEditForm
      onSubmit={onSubmit}
      onClose={onClose}
      data={aggregatedData}
    />
  )
}
